import { MutedAlert } from '@app/components/MutedAlert';
import { Link as MuiLink } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

interface SocialExportNoSourcesAlertProps {
  fragmentId: string;
}

const noSourcesMessage = defineMessage({
  id: 'fragments.socialExport.panorama.noSources',
  defaultMessage:
    'Para publicar en redes sociales es necesario generar un video a partir del fragmento.',
});

const goToEditionMessage = defineMessage({
  id: 'fragments.socialExport.panorama.goToEdition',
  defaultMessage: 'Ir a edición',
});

/**
 * Alert shown when social export has no publishable source for the current fragment.
 */
export function SocialExportNoSourcesAlert({ fragmentId }: SocialExportNoSourcesAlertProps) {
  return (
    <MutedAlert sx={{ mt: 2 }}>
      <FormattedMessage {...noSourcesMessage} />{' '}
      <MuiLink component={Link} to={`/fragments/${fragmentId}/video-editions`} underline="hover">
        <FormattedMessage {...goToEditionMessage} />
      </MuiLink>
    </MutedAlert>
  );
}
